<template>
  <section
    :class="[
      'album-collection',
      { 'album-collection--nested': isUsedInArticle },
      { 'album-collection--theme': isUsedInArticle && coverings.length > 1 },
    ]"
  >
    <div class="coverings" v-for="(cover, index) in coverings" :key="index">
      <ArticleFavourite v-if="hasFavourite" :favouriteId="cover.favourite_id" />

      <router-link
        :to="{ name: displayType, params: { articleId: cover.id } }"
        :title="`[前往]${cover.title}圖鑑集`"
      >
        <div class="coverings__cover">
          <img
            class="coverings__cover-image lazyload"
            style="opacity: 1;"
            :alt="''"
            :src="cover.cover_image_url"
          />
          <!-- 暫時隱藏 lazy-loading -->
          <!-- <img
            class="coverings__cover-image lazyload"
            :alt="cover.cover_image_description ? cover.cover_image_description : '' "
            :data-reference="cover.cover_image_url"
          />-->
          <noscript>
            <img
              class="coverings__cover-image"
              style="opacity: 1;"
              :alt="''"
              :src="cover.cover_image_url"
            />
          </noscript>
        </div>
        <div
          class="coverings__photos"
          v-if="cover.images ? cover.images.length : cover.images"
        >
          <span
            class="coverings__photo"
            v-for="(photo, index) in getTwoPhotosOfAlbum(cover.images)"
            :key="index"
          >
            <!-- 首頁 API 圖片格式沒有 image_url -->
            <!-- 暫時隱藏 lazy-loading -->
            <img
              class="coverings__photo-image lazyload"
              style="opacity: 1;"
              :src="photo.image_url ? photo.image_url : photo"
              :alt="''"
            />
            <!-- <img
              class="coverings__photo-image lazyload"
              :alt="''"
              :data-reference="(photo.image_url) ? photo.image_url : photo"
            />-->
            <noscript>
              <img
                class="coverings__photo-image"
                style="opacity: 1;"
                :alt="''"
                :src="photo.image_url ? photo.image_url : photo"
              />
            </noscript>
          </span>
        </div>
        <slot name="title" v-bind:cover="cover"></slot>
      </router-link>
    </div>
    <slot></slot>
  </section>
</template>

<script>
import ArticleFavourite from '@/components/article/ArticleFavourite';

export default {
  name: 'AlbumCollection',
  props: {
    displayType: {
      type: String,
      default: '',
    },
    coverings: {
      type: Array,
      default: () => [],
    },
    isUsedInArticle: {
      type: Boolean,
      default: false,
    },
    hasFavourite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    getTwoPhotosOfAlbum: function(album) {
      return album.slice(0, 2);
    },
  },
  components: {
    ArticleFavourite,
  },
};
</script>

<style lang="scss" scoped>
@keyframes loading {
  from {
    background-position-x: 100%;
  }
  to {
    background-position-x: 0%;
  }
}

.album-collection {
  @include for-tablet {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    max-width: 768px;
    margin: auto;
  }

  &--nested {
    @include for-tablet {
      max-width: 605px;
      margin-left: 0;
      margin-right: 0;
    }

    @include for-tablet-horizontal {
      max-width: 930px;
    }
  }

  &--theme {
    .coverings {
      /* @include for-tablet {
      margin-bottom: 20px;
      } */

      @include for-tablet-horizontal {
        margin-bottom: 0;
        margin-left: 20px;

        &:nth-child(3n + 1) {
          margin-left: 0;
        }
      }

      @include for-desktop {
        margin-bottom: 20px;
      }
    }

    &:last-child {
      @include for-desktop {
        margin-bottom: 0;
      }
    }

    .coverings + .coverings {
      margin-top: 20px;

      @include for-tablet {
        margin-top: 0;
        margin-left: 20px;
      }

      @include for-tablet-horizontal {
        margin-left: 45px;
      }

      @include for-desktop {
        margin-left: 0;
      }
    }
  }
}

.coverings {
  position: relative;

  @include for-desktop {
    margin-left: 45px;

    &:nth-child(3n + 1) {
      margin-left: 0;
    }
  }

  &__cover,
  &__photo {
    position: relative; // for mockup positioning
  }

  &__cover {
    text-align: center;
    margin-bottom: 10px;
  }

  &__cover-image,
  &__photo-image {
    object-fit: cover;
  }

  &__cover-image {
    height: 210px;
  }

  &__photo-image {
    height: 135px;
  }

  &__cover-image,
  h4 {
    width: 280px;
  }

  &__photos {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    width: auto;
    max-width: 280px;
  }

  &__photo {
    flex-basis: 50%;
    max-width: 135px;
    font-size: 0;

    /* &:nth-child(1) {
      padding-right: 6px;
    }

    &:nth-child(2) {
      padding-left: 6px;
    } */

    &-image {
      width: 100%;
    }
  }

  img {
    opacity: 0;
    transition: opacity 600ms ease-in;
  }

  .favourite {
    opacity: 1;
  }
}
</style>
